import { stepperAnatomy } from '@chakra-ui/anatomy';
import { createMultiStyleConfigHelpers } from '@chakra-ui/react';

const { definePartsStyle, defineMultiStyleConfig } =
  createMultiStyleConfigHelpers(stepperAnatomy.keys);

export const stepperRecipe = defineMultiStyleConfig({
  baseStyle: definePartsStyle(({ colorScheme }) => ({
    stepper: {
      '&[data-orientation=horizontal]': {
        gap: '0',
      },
    },
    number: {
      fontWeight: 'bold',
      fontSize: { base: '22px', lg: '33px' },
      color: 'gray.700',
    },
    step: {
      gap: '0',
    },
    separator: {
      '&[data-orientation=horizontal]': {
        height: '1.5',
        marginInlineStart: '0',
        backgroundColor: `${colorScheme}.50`,
        '&[data-status=complete]': {
          backgroundColor: `${colorScheme}.300`,
        },
      },
    },
    indicator: {
      width: { base: '64px', lg: '102px' },
      height: { base: '64px', lg: '102px' },
      borderRadius: '18px',
      position: 'relative',
      '&[data-status=incomplete]': {
        bg: 'white',
        borderWidth: '9px',
      },
      '&[data-status=active], &[data-status=complete]': {
        bg: `${colorScheme}.200`,
        borderColor: `${colorScheme}.300`,
        borderWidth: '9px',
      },
    },
    title: {
      fontSize: { base: 'xs', lg: 'lg' },
      color: 'primary.500',
      position: 'absolute',
      top: { base: '12', lg: '28' },
      textAlign: 'center',
      width: { base: '150%', lg: '100%', xl: 'max-content' },
      '&[data-status=incomplete]': {
        color: 'gray.700',
      },
    },
  })),
  sizes: {
    sm: {
      indicator: {
        width: { base: '54px', lg: '102px' },
        height: { base: '54px', lg: '102px' },
        '&[data-status=incomplete]': {
          borderWidth: '4px',
        },
        '&[data-status=active], &[data-status=complete]': {
          borderWidth: '4px',
        },
      },
    },
  },
  defaultProps: {
    colorScheme: 'secondary',
  },
});
